<div class="card mb-5">
	<div class="card-header">
		<h3>Histórico de Configuraciones de Recurrencia</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<h5>Filtrar</h5>
				<div class="form-group">
					<div class="input-group">
						<input type="text" id="filterVendors" [(ngModel)]="search"
							placeholder="Ingresa bodega o tipo de recurrencia" name="filterVendors"
							class="form-control">
						<button class="btn btn-primary" (click)="searching()">
							<i class="fa fa-search"></i>
						</button>
					</div>
				</div>
				<div class="table-responsive" [class.table-responsive-without]="waitingFor" style="margin-bottom: 0;">
					<table class="table table-striped" style="margin-bottom: 0;">
						<thead>
							<tr>
								<th class="td-center">
									Nombre
								</th>
								<th class="td-center">
									Bodega
								</th>
								<th class="td-center">
									Recurrencia
								</th>
								<th class="td-center">
									Fecha Inicial
								</th>
								<th class="td-center">
									Fecha Final
								</th>
								<th class="td-center">
									Fecha Factura
								</th>
								<th class="td-center">
									Estado
								</th>
								<th class="td-center">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let recurrence of pagination.filter">
								<tr [class.hide-all]="waitingFor?.id==recurrence.id">
									<td class="td-center">
										<ng-container *ngIf="recurrence.description">
											{{recurrence.description}}
										</ng-container>
										<ng-container *ngIf="!recurrence.description">
											<span class="opacity-30"><i class="fa fa-circle-info"></i>Sin nombre.</span>
										</ng-container>
									</td>
									<td class="td-center">
										{{recurrence.name}}
									</td>
									<td class="td-center">
										{{recurrence.recurrence}}
									</td>
									<td class="td-center">
										{{recurrence.startDate | date: 'dd-MM-YYYY'}}
									</td>
									<td class="td-center">
										{{recurrence.endDate | date: 'dd-MM-YYYY'}}
									</td>
									<td class="td-center">
										{{recurrence.billingDate | date: 'dd-MM-YYYY'}}
									</td>
									<td class="td-center">
										{{recurrence.isActive == true ? 'En espera' : 'Enviado'}}
									</td>
									<td class="td-center">
										<div style="display: flex; justify-content: space-around;">
											<span tooltip="Ver"
												(click)="showRecurrenceDetail(recurrence.factId)" class="clickeable text-info">
												<span *ngIf="!gettingRecurrence" class="superposition-container">
													<i class="fa fa-eye"></i>
													<i class="fa-solid fa-arrows-rotate superposition-element"></i>
												</span>
												<span *ngIf="gettingRecurrence" class="spinner-border spinner-border-sm"
													aria-hidden="true"></span>
											</span>
											<!-- <div class="container-superposition">
												<div class="element-superposition"
													*ngIf="waitingFor?.id == recurrence.id">
													<span>¿Está seguro que desea eliminar esta configuración?</span>
													<span class="a-container">
														<span class="a-hover" (click)="resetDeletingDiv()"><i
																class="fa fa-ban"></i>NO</span>
														<span class="a-hover text-danger"
															(click)="confirmDelete(recurrence)"><i
																class="fa fa-trash"></i>SÍ</span>
													</span>
												</div>
												<span tooltip="Eliminar" class="clickeable text-danger"
													(click)="deleteRecurrence(recurrence)">
													<i *ngIf="!deleting[recurrence.id]" class="fa fa-trash"></i>
													<span *ngIf="deleting[recurrence.id]"
														class="spinner-border spinner-border-sm"
														aria-hidden="true"></span>
												</span>
											</div> -->
										</div>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="pagination.filter.length == 0">
								<td colspan="7" class="td-center" style="color: gray">
									<i class="fa fa-circle-info"></i>No se encontraron configuraciones
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
</div>
<div class="hide-background" *ngIf="waitingFor">
	<div class="for-click" (click)="resetDeletingDiv()"></div>
</div>
<div class="container-idle" *ngIf="recurrenceDetail">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Detalle de Configuración</h1>
					<h1 style="left: 0;" class="i-hover">
						<i class="fa fa-xmark" (click)="recurrenceDetail = null"></i>
					</h1>
				</div>
				<div class="modal-body">
					<div class="detalle-container">
						<div class="detalle-item"><strong>Descripción:</strong> {{ recurrenceDetail.description }}</div>
						<div class="detalle-item"><strong>Fecha Inicio:</strong> {{ recurrenceDetail.startDate | date: 'dd-MM-yyyy' }}</div>
						<div class="detalle-item"><strong>Fecha Fin:</strong> {{ recurrenceDetail.endDate | date: 'dd-MM-yyyy' }}</div>
						<div class="detalle-item"><strong>Fecha Factura:</strong> {{ recurrenceDetail.billingDate | date: 'dd-MM-yyyy' }}</div>
						<div class="detalle-item"><strong>Hora de Inicio:</strong> {{ recurrenceDetail.startTime | date:'HH:mm:ss' }}</div>
						<div class="detalle-item"><strong>Hora de Finalización:</strong> {{ recurrenceDetail.endTime | date:'HH:mm:ss' }}</div>
					  
						<div class="detalle-item" *ngIf="recurrenceDetail.isPartial !== null"><strong>Cantidad Parcial:</strong> {{ recurrenceDetail.isPartial == true ? "Verdadero" : "Falso"}}</div>
						<div class="detalle-item" *ngIf="recurrenceDetail.unifiedProducts !== null"><strong>Productos Unificados:</strong> {{ recurrenceDetail.unifiedProducts == true ? "Verdadero" : "Falso" }}</div>
						<div class="detalle-item" *ngIf="recurrenceDetail.cashierId !== null"><strong>Forma de pago:</strong> {{ cashierName }}</div>
						<div class="detalle-item" *ngIf="recurrenceDetail.limitPrice !== null"><strong>Limite de precio:</strong> {{ recurrenceDetail.limitPrice }}</div>
					  
						<div class="detalle-item" *ngIf="recurrenceDetail.receiptNumber"><strong>Numero de Recibo:</strong> {{ recurrenceDetail.receiptNumber }}</div>
						<div class="detalle-item" *ngIf="recurrenceDetail.bankDescription"><strong>Banco:</strong> {{ recurrenceDetail.bankDescription }}</div>
					</div>
					  

					<hr>
					<h5>Resumen de Productos</h5>
					<table class="table table-striped table-bordered" *ngIf="productSummary.length > 0; else noProductSummary">
					<thead>
						<tr>
						<th>Producto</th>
						<th>Cantidad Total</th>
						<th>Cantidad Limite</th>
						<th>Precio Unitario</th>
						<th>Total</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let p of productSummary">
						<td>{{ p.name }}</td>
						<td>{{ p.totalQuantity }}</td>
						<td>{{ p.limitProduct == null ? "" : p.limitProduct }}</td>
						<td>{{ (p.totalPrice / p.totalQuantity) | number:'1.2-2' }}</td>
						<td>{{ p.totalPrice | number:'1.2-2' }}</td>
						</tr>
					</tbody>
					</table>
					<ng-template #noProductSummary>
					<p class="text-muted">No hay resumen de productos.</p>
					</ng-template>

					<hr>
					<h5>Resumen de Clientes</h5>
					<ul *ngIf="clientSummary.length > 0; else noClientSummary">
					<li *ngFor="let c of clientSummary">
						{{c.name}} - Aparece: {{c.count}} {{c.count === 1 ? 'vez' : 'veces'}}
					</li>
					</ul>
					<ng-template #noClientSummary>
					<p class="text-muted">No hay resumen de clientes.</p>
					</ng-template>
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" (click)="recurrenceDetail = null">
						<i class="fa fa-xmark"></i> Cerrar
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

  